import { ReactElement } from 'react';

import { CalendarHeaderWrapper } from './calendar.styled';
import { CalendarHeaderLegend } from './CalendarHeaderLegend';
import {
  CalendarHeaderUnderLine,
  CalendarHeaderUnderLineProps,
} from './CalendarHeaderUnderLine';
import {
  SearchPatientForm,
  SearchPatientFormProps,
} from '../search-patient/SearchPatientForm';

type Props = {
  searchPatientFormProps: SearchPatientFormProps;
  calendarHeaderUnderLineProps: CalendarHeaderUnderLineProps;
};

export const CalendarHeader = ({
  searchPatientFormProps,
  calendarHeaderUnderLineProps,
}: Props): ReactElement => {
  return (
    <>
      <CalendarHeaderWrapper>
        <SearchPatientForm {...searchPatientFormProps} />
        <CalendarHeaderLegend />
      </CalendarHeaderWrapper>
      <CalendarHeaderUnderLine {...calendarHeaderUnderLineProps} />
    </>
  );
};
